import { AioExternalReplacements, AioReplacement } from "./interface";
import { updateExternal } from "./updateExternal";

/**
 * Update base list with external lists.
 *
 * @param reps - Replacements from the tlf
 * @param exts - External replacements
 * @returns AioReplacement<T>[] | undefined
 */
export const updateExternals = <T>(
  reps?: AioReplacement<T>[],
  exts?: AioExternalReplacements<T>[],
): AioReplacement<T>[] | undefined => {
  return reps?.map((rep) => updateExternal(rep, exts));
};
